import React from 'react';
import {useField} from 'formik';
import {t} from 'ttag';
import {Toggle} from '../../../../../../form/form.jsx';

const IsSmsProviderEnabled = () => {
  const [field, , helpers] = useField('is_sms_provider_enabled');

  return (
    <Toggle
      label={t`Available for SMS`}
      onChange={helpers.setValue}
      isChecked={field.value}
    />
  );
};

export default IsSmsProviderEnabled;
